// Default options for pikaday widget
// that provides calendar for date chose

var pikaday_i18n = {
  previousMonth: "Poprzedni miesiąc",
  nextMonth: "Następny miesiąc",
  months: [
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień"
  ],
  weekdays: [
    "Niedziela",
    "Poniedziałek",
    "Wtorek",
    "Środa",
    "Czwartek",
    "Piątek",
    "Sobota"
  ],
  weekdaysShort: ["Nie", "Pon", "Wto", "Śro", "Czw", "Pią", "Sob"]
};

export function getPikadayOptions() {
  return {
    bound: true,
    i18n: pikaday_i18n,
    format: "YYYY-MM-DD",
    formatStrict: true,
    setDefaultDate: true,
    defaultDate: new Date(),
    numberOfMonths: 3
  };
}
